export default __webpack_public_path__ + "static/shop-silpo-101224404ecd6ca962b3b2046ab6b1e4.svg";